import { FilterValue, filterValueFromResponse } from './FilterValue';
import { TranslatedText } from '../Translation';

export interface FilterWithValues {
  id: number;
  slug: string;
  title: string;
  titleTranslation: TranslatedText;
  isActive: boolean;
  values: FilterValue[];
}

export const getEmptyFilterWithValues = (): FilterWithValues => ({
  id: 0,
  slug: '',
  title: '',
  titleTranslation: {},
  isActive: false,
  values: [],
});

export const filterWithValuesFromResponse = (
  responseData: any,
): FilterWithValues => ({
  id: responseData.id,
  slug: responseData.slug,
  title: responseData.title,
  titleTranslation: responseData.title_translation ?? {},
  isActive: responseData.is_active,
  values: responseData.values.map((value: any) =>
    filterValueFromResponse(value),
  ),
});

export const filterWithValuesToUpsertRequest = (
  filterWithValues: FilterWithValues,
) => ({
  title: filterWithValues.title,
  title_translation: filterWithValues.titleTranslation,
  is_active: filterWithValues.isActive,
});
